import { Button } from "primereact/button";
import { Props } from "./types";

export function SyncFooter({
  loading,
  isSuccess,
  error,
  message,
  onStart,
  onCancel,
}: Props) {
  return (
    <>
      {!loading ? (
        <Button
          label="Synchronize Now"
          icon="pi pi-sync"
          onClick={onStart}
          className="p-button-primary w-full"
        />
      ) : (
        <div className="flex gap-2 w-full">
          <Button
            label="Synchronizing..."
            icon="pi pi-spin pi-spinner"
            disabled
            className="p-button-secondary flex-1"
          />
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text p-button-danger"
            onClick={onCancel}
          />
        </div>
      )}

      {!loading && isSuccess && (
        <div className="flex align-items-center gap-2 text-green-600 font-medium">
          <i className="pi pi-check-circle" />
          <span>{message}</span>
        </div>
      )}

      {!loading && error && (
        <div className="flex align-items-center gap-2 text-red-600 font-medium">
          <i className="pi pi-times-circle" />
          <span>Synchronization failed: {error.message}</span>
        </div>
      )}
    </>
  );
}
